import { useMutation } from "@tanstack/react-query"

import { fileToBase64 } from "@/utils/fileUtils"

import { publicApi } from "../apiClient"

interface UploadFileParams {
  file: File
  localId: string
  fileType: "Photo" | "PersonCertificate"
}

interface SaveTemporaryFileRequest {
  localId: string
  fileType: string
  data: string
  fileName: string
  mimeType: string
}

interface SaveTemporaryFileResponse {
  FileId: string
}

export const useFileUpload = () => {
  const uploadFileMutation = useMutation<
    { fileId: string; base64: string },
    Error,
    UploadFileParams
  >({
    mutationKey: ["uploadFile"],
    mutationFn: async ({ file, localId, fileType }) => {
      const base64 = await fileToBase64(file)

      const requestBody: SaveTemporaryFileRequest = {
        localId,
        fileType,
        data: base64,
        fileName: file.name,
        mimeType: file.type,
      }

      const response = await publicApi.post<SaveTemporaryFileResponse>(
        `/skipass/app/cart/file`,
        requestBody
      )

      return { fileId: response.data.FileId, base64: base64 }
    },
    retry: 1,
  })

  const { mutate, isPending, error, isSuccess, reset } = uploadFileMutation

  return {
    uploadFile: mutate,
    isUploading: isPending,
    error,
    isSuccess,
    resetError: reset,
  }
}
